"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEV_UNAUTHENTICATED_MOBILE_AUTHENTICATOR_LAMBDA_ARNS = exports.DEV_MOBILE_AUTHENTICATOR_LAMBDA_ARNS = exports.DEV_BLOCKING_AUTHENTICATOR_LAMBDA_ARNS = exports.DEV_COOKIE_AUTHENTICATOR_LAMBDA_ARNS = void 0;
const Stage_1 = require("./Stage");
/**
 * See https://github.com/eventbrite/tlz-request-based-authorizer-infra for more details
 */
exports.DEV_COOKIE_AUTHENTICATOR_LAMBDA_ARNS = {
    [Stage_1.Stage.LOCAL]: "arn:aws:lambda:us-east-1:477496631753:function:unauthenticated_authorizer:developer",
    [Stage_1.Stage.DEV]: "arn:aws:lambda:us-east-1:477496631753:function:unauthenticated_authorizer:developer",
    [Stage_1.Stage.TEST]: "arn:aws:lambda:us-east-1:686954813705:function:unauthenticated_authorizer:developer",
    [Stage_1.Stage.PROD]: "arn:aws:lambda:us-east-1:971103245699:function:unauthenticated_authorizer:developer",
};
exports.DEV_BLOCKING_AUTHENTICATOR_LAMBDA_ARNS = {
    [Stage_1.Stage.LOCAL]: "arn:aws:lambda:us-east-1:477496631753:function:authenticated_signed_cookie_authorizer:developer",
    [Stage_1.Stage.DEV]: "arn:aws:lambda:us-east-1:477496631753:function:authenticated_signed_cookie_authorizer:developer",
    [Stage_1.Stage.TEST]: "arn:aws:lambda:us-east-1:686954813705:function:authenticated_signed_cookie_authorizer:developer",
    [Stage_1.Stage.PROD]: "arn:aws:lambda:us-east-1:971103245699:function:authenticated_signed_cookie_authorizer:developer",
};
exports.DEV_MOBILE_AUTHENTICATOR_LAMBDA_ARNS = {
    [Stage_1.Stage.LOCAL]: "arn:aws:lambda:us-east-1:477496631753:function:mobile_authorizer:developer",
    [Stage_1.Stage.DEV]: "arn:aws:lambda:us-east-1:477496631753:function:mobile_authorizer:developer",
    [Stage_1.Stage.TEST]: "arn:aws:lambda:us-east-1:686954813705:function:mobile_authorizer:developer",
    [Stage_1.Stage.PROD]: "arn:aws:lambda:us-east-1:971103245699:function:mobile_authorizer:developer",
};
exports.DEV_UNAUTHENTICATED_MOBILE_AUTHENTICATOR_LAMBDA_ARNS = {
    [Stage_1.Stage.LOCAL]: "arn:aws:lambda:us-east-1:477496631753:function:unauthenticated_mobile_authorizer:developer",
    [Stage_1.Stage.DEV]: "arn:aws:lambda:us-east-1:477496631753:function:unauthenticated_mobile_authorizer:developer",
    [Stage_1.Stage.TEST]: "arn:aws:lambda:us-east-1:686954813705:function:unauthenticated_mobile_authorizer:developer",
    [Stage_1.Stage.PROD]: "arn:aws:lambda:us-east-1:971103245699:function:unauthenticated_mobile_authorizer:developer",
};
//# sourceMappingURL=developmentLambdaAuthenticators.js.map